module.exports = __webpack_public_path__ + "static/media/req-workspace-buyer-lawyer-help3.39084b9c.svg";